import { createActions, createReducer } from 'reduxsauce'

import ContratoAtaService from '../../servicos/DetalhesAtaRegistroPrecoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaContratoAtaInicio: [],
    buscaContratoAtaSucesso: ['contratoAta'],
    buscaContratoAtaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaContratoAta = filtro => {
    return dispatch => {
        dispatch(Creators.buscaContratoAtaInicio())
        let serv = new ContratoAtaService()
        return serv
            .consultarContratoAta(filtro)
            .then(response => dispatch(Creators.buscaContratoAtaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaContratoAtaErro(error)))
    }
}

const buscaContratoAtaInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaContratoAtaErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaContratoAtaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.contratoAta, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONTRATO_ATA_INICIO]: buscaContratoAtaInicio,
    [Types.BUSCA_CONTRATO_ATA_ERRO]: buscaContratoAtaErro,
    [Types.BUSCA_CONTRATO_ATA_SUCESSO]: buscaContratoAtaSucesso,
})
